import React, { ReactNode } from 'react';
import { ASSET_PREFIX } from 'utils/constants';
import styles from './GenericButton.module.css';

interface GenericButtonProps {
  children: ReactNode;
  disabled?: boolean;
  loading?: boolean;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

const GenericButton: React.FC<GenericButtonProps> = ({
  children,
  disabled = false,
  loading = false,
  onClick,
}) => {
  const isInactive = disabled || loading;
  const displayContent = loading ? (
    <img
      src={`${ASSET_PREFIX}/images/spinner-black.svg`}
      style={{ width: 'auto', height: '30px', alignSelf: 'center' }}
    />
  ) : (
    children
  );

  return (
    <button
      onClick={(e) => onClick(e)}
      disabled={isInactive}
      className={`${styles.buttonContainer} arcadeFont`}
    >
      {displayContent}
    </button>
  );
};

export default GenericButton;
